import { Component } from '@angular/core';

@Component({
    selector: 'app-indeterminate-loading-bar',
    template: `<ngb-progressbar></ngb-progressbar>`,
    styleUrls: ['./indeterminate-loading-bar.component.scss']
})
export class IndeterminateLoadingBarComponent {}
